import { ProductionStatus } from "@enums/productionStatus.enum";

export interface CloseSupervisorRequest {
	closingComments: string;
	newStatus?: ProductionStatus;
	supervisorId: number;
	supervisorRequestId: number;
}

export class CloseSupervisorRequest implements CloseSupervisorRequest {
	constructor(data?: Partial<CloseSupervisorRequest>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}